import config from '../../../config'

import {
    login,
    loginRequest,
    logout,
    logoutRequest,
    setLoading,
    setAuthorize,
    userInfoRequest,
    availableModulesRequest,
} from '../actions'

describe('Authorization service actions', () => {
    test('login', () => {
        const action = {
            type: 'LOGIN',
            data: {
                username: 'test',
                password: 'test',
                autologin: true,
                id: '200',
                sessionId: 'sesTest',
                uniqueId: null,
                redirectModule: 'report',
                language: 'sk',
            },
        }

        expect(
            login({
                username: 'test',
                password: 'test',
                autologin: true,
                id: '200',
                sessionId: 'sesTest',
                uniqueId: null,
                redirectModule: 'report',
                language: 'sk',
            })
        ).toEqual(action)
    })

    test('loginRequest', () => {
        const action = {
            type: 'LOGIN_REQUEST',
            payload: {
                ...config.api.login,
                formData: 'user_name=martin.kadlec&password=heslo&replace_existing=true',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
            },
        }

        expect(loginRequest('martin.kadlec', 'heslo')).toEqual(action)
    })

    test('loginRequest should escape form data', () => {
        const action = {
            type: 'LOGIN_REQUEST',
            payload: {
                ...config.api.login,
                formData: 'user_name=martin%2Bkadlec&password=aaa%2B.aaa&replace_existing=true',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
            },
        }

        expect(loginRequest('martin+kadlec', 'aaa+.aaa')).toEqual(action)
    })

    test('logout', () => {
        const action = { type: 'LOGOUT' }

        expect(logout()).toEqual(action)
    })

    test('logoutRequest', () => {
        const action = {
            type: 'LOGOUT_REQUEST',
            payload: {
                ...config.api.logout,
                headers: {
                    Accept: 'text/plain',
                },
            },
        }

        expect(logoutRequest()).toEqual(action)
    })

    test('setLoading', () => {
        const actionTrue = {
            type: 'SET_LOADING',
            data: {
                isLoading: true,
            },
        }

        expect(setLoading(true)).toEqual(actionTrue)

        const actionFalse = {
            type: 'SET_LOADING',
            data: {
                isLoading: false,
            },
        }

        expect(setLoading(false)).toEqual(actionFalse)

        // empty branch
        expect(setLoading()).toEqual(actionFalse)
    })

    test('setAuthorize', () => {
        const actionTrue = {
            type: 'SET_AUTHORIZE',
            data: {
                isAuthorized: true,
            },
        }

        expect(setAuthorize(true)).toEqual(actionTrue)

        const actionFalse = {
            type: 'SET_AUTHORIZE',
            data: {
                isAuthorized: false,
            },
        }

        expect(setAuthorize(false)).toEqual(actionFalse)

        // empty branch
        expect(setAuthorize()).toEqual(actionFalse)
    })

    test('userInfoRequest', () => {
        const action = {
            type: 'USER_INFO_REQUEST',
            payload: {
                ...config.api.userInfo,
                headers: {
                    sid: 'gnosus/123456789',
                },
                qs: {
                    sid: '123456789',
                },
            },
        }

        expect(userInfoRequest('123456789')).toEqual(action)
    })

    test('availableModulesRequest', () => {
        const action = {
            type: 'AVAILABLE_MODULES_REQUEST',
            payload: {
                ...config.api.availableModules,
                qs: {
                    sid: '123456789',
                },
            },
        }

        expect(availableModulesRequest('123456789')).toEqual(action)
    })
})
